<template>
<v-app :style="{ backgroundColor: `${APP_COLOR}` }">
	<v-progress-linear
		v-if="loading"
		indeterminate
		color="primary"
	/>
	<NavBar />
	<v-main
		v-if="!loading"
		:style="{ backgroundColor: 'white' }"
	>
		<router-view />
	</v-main>
	<NotifySnackbar />
</v-app>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue'
import NotifySnackbar from '@/components/general/NotifySnackbar.vue'
import { HTTP } from './services/http'
import { Settings } from '@/settings'
import { Notify } from '@/modules/util/notify'
import './modules/util/log'
import { UserService } from './services/user-service'

export default {
	name: 'App',
	components: {
		NavBar,
		NotifySnackbar,
	},
	data() {
		return {
			loading: true,
			APP_COLOR: Settings.APP_COLOR,
		}
	},
	async mounted() {
		const success = await Settings.init()
		if (!success) {
			Notify.error('Failed to load site config')
			return
		}

		HTTP.initCacheRetry()

		this.loading = false

		// if loaded on login page, redirect to home
		if (UserService.hasAuth() && this.$route.path === '/login') {
			this.$router.push({ name: 'home' })
		}
	},
	unmounted() {
		HTTP.stopCacheRetry()
	},
}
</script>

<style>
html,
body {
  overscroll-behavior-y: contain;
  touch-action: pan-x pan-y;
  overflow-y: auto;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
